import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'

export default {
  code: 99,
  [BIKE_ATTRIBUTES.TYPE.ITEM_COLOR]: 1,
  [BIKE_ATTRIBUTES.TYPE.ITEM_FILTER_COLOR]: 1,
  [BIKE_ATTRIBUTES.TYPE.ITEM_GENDER_FRAME]: 1,
  [BIKE_ATTRIBUTES.TYPE.EBIKE_ENGINE_MODEL]: 1,
  [BIKE_ATTRIBUTES.TYPE.EBIKE_SYSTEM_BRAND]: 1,
  [BIKE_ATTRIBUTES.TYPE.PRODUCT_MAIN_CATEGORY]: 1,
  [BIKE_ATTRIBUTES.TYPE.PRODUCT_BIDEX_COMMODITY_GROUP]: 1,
  [BIKE_ATTRIBUTES.TYPE.ITEM_WHEEL_SIZE_INCH]: 1,
  [BIKE_ATTRIBUTES.TYPE.ITEM_BATTERY_WATT_HOURS]: 1,
  [BIKE_ATTRIBUTES.TYPE.PRODUCT_GEAR_TYPE]: 1,
  [BIKE_ATTRIBUTES.TYPE.ITEM_COASTER_BRAKE]: 1,
  [FILTER_CONSTANTS.TYPE.STOCK]: 1,
}
